module.exports = __webpack_public_path__ + "img/example-customer.264664f1.png";